import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

import { firebaseReducer } from "react-redux-firebase";
import { firestoreReducer } from "redux-firestore";

const createRootReducer = (history: any) => {
  const reducerBase = combineReducers({
    firebase: firebaseReducer,
    firestore: firestoreReducer,
    router: connectRouter(history),
  });

  const rootReducer = (state: any, action: { type: string }) => {
    // if (action.type === "RESET_APP") {
    //   state = undefined;
    // }

    return reducerBase(state, action);
  };

  return rootReducer;
};

export default createRootReducer;
